import vm from '@/main'

const i18n = param => vm.$t(`_staff.labelCert.${param}`)
export default () => {
  const column = [
    {
      label: i18n('certName'),
      field: 'certName',
      formOption: {
        rules: 'required',
      },
      class: 'table-td table-td-sm',
    },
    {
      label: i18n('certType'),
      field: 'certType',
      dictField: 'certTypeName',
      type: 'select',
      dictBizCode: 'staff_cert_type',
      class: 'table-td table-td-sm',
    },
    {
      label: i18n('certFiles'),
      field: 'certFiles',
      dictField: 'attachs',
      class: 'table-td',
      type: 'upload',
      uploadLimit: 10,
      size: 'sm',
    },
  ]
  return column
}
